//src/services/campaigns-service.js
import api from '../utils/api';
import qs from '../utils/qs';

const hasTemplatePreview = (template) => {
    if (!template || typeof template !== 'object') {
        return false;
    }
    const rawTemplate = template.dataValues && typeof template.dataValues === 'object'
        ? template.dataValues
        : template;
    return Boolean(String(rawTemplate.thumbnail_url || '').trim());
};

export const filterTemplatesWithPreview = (templates = []) =>
    (Array.isArray(templates) ? templates : []).filter(hasTemplatePreview);

export const getCampaigns = async (params) => {
    try {
        const response = await api.get(`/campaigns/v2?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getactorassignedcampaigns = async (data) => {
    try {
        const response = await api.get(`/actor-onboarding/actor?${qs(data)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getCampaignsById = async (id) => {
    try {
        const response = await api.get(`/campaigns/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getCampaignByIdV3 = async (id) => {
    try {
        const response = await api.get(`/campaigns/v3/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const addCampaigns = async (data) => {
    try {
        const response = await api.post(`/campaigns`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.message };
    }
}

export const editCampaigns = async (params, data) => {
    try {
        const response = await api.post(`/campaigns/update/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.message };
    }
}

export const deleteCampaigns = async (params) => {
    try {
        const response = await api.delete(`/campaigns/${params}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const deleteDraftCampaigns = async (params) => {
    try {
        const response = await api.delete(`/draft-campaigns/${params}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getCampaignsActorById = async (params) => {
    try {
        const { id, actorid, ...qsParams } = params || {};
        const response = await api.get(`/campaigns/${id}/videos/${actorid}?${qs(qsParams)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getCampaignsFormActorById = async (params) => {
    try {
        const response = await api.get(`/campaigns/${params.id}/actors?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getDraftCampaigns = async (campaignId) => {
    try {
        // const { id, actorid } = params;
        const response = await api.get(`/campaigns/fetchcampaign/${qs(campaignId)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getallDraftCampaigns = async (params) => {
    try {
        // const { id, actorid } = params;
        const response = await api.get(`/campaigns/fetchAllCampaign?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        //console.log(error)
        return { error: error?.response?.data?.message };
    }
}

export const updateDraftCampaigns = async (payload, id) => {
    try {
        const response = await api.post(`/campaigns/update_draft/${id}`, payload)
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        //console.log(error);
        return { error: error?.message };
    }
}

export const updateCampaignForRename = async (payload) => {
    try {
        const formData = new FormData();
        formData.append('title', payload?.title || '');
        formData.append('theme', payload?.theme || '');
        formData.append('count', payload?.count ?? 0);
        formData.append('draftId', payload?.draftId || '');
        formData.append('aspectRatio', payload?.aspectRatio || '1:1');
        formData.append('aspect_ratio', payload?.aspectRatio || '1:1');
        formData.append('renderStrategy', payload?.renderStrategy || 'remotion');
        if (payload?.source_channel) formData.append('source_channel', payload.source_channel);
        if (payload?.source_type) formData.append('source_type', payload.source_type);
        if (payload?.template_id) formData.append('template_id', payload.template_id);
        if (payload?.source_metadata) formData.append('source_metadata', JSON.stringify(payload.source_metadata));

        const response = await api.post('/campaigns/createdDraftCampaign', formData);
        if (response?.status === 200) {
            return response?.data;
        }
        return { error: 'Failed to update campaign title.' };
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message || 'Failed to update campaign title.' };
    }
}

export const updateCampaignInvites = async (payload) => {
    try {
        const response = await api.post(`/campaigns/invite-actors`, payload);
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        //console.log(error);
        return { error: error?.response?.data?.error };
    }
}

export const getAllActorsForCampaignAttached = async (campaign_id) => {
    try {
        const params = {
            campaign_id: campaign_id
        }
        const response = await api.get(`/campaign-actors/unassigned-actors?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        //console.log(error);
        return { error: error?.response?.data?.message };
    }
}

export const fetchallwhatsappcontacts = async (account_id) => {
    try {
        const params = {
            account_id: account_id
        }
        const response = await api.get(`/whatsapp/getwhatsapmapping?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        //console.log(error);
        return { error: error?.response?.data?.message };
    }
}

export const getAllInvitedActors = async (campaign_id) => {
    try {
        const response = await api.get('/campaign-actors/invited-actor', {
            params: { campaign_id }
        });
        return response.data; // this returns full campaign object
    } catch (error) {
        console.error("Failed to fetch invited actors:", error);
        return { error: error.message };
    }
};

export const publishCampaign = async (payload) => {
    try {
        const response = await api.post("/campaigns/publish", payload)
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {error: error?.response?.data?.message}
    }
}

export const cloneCampaign = async (payload) => {
    try {
        const response = await api.post('/campaigns/clone', payload);
        if (response?.status === 201 || response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.error || error?.response?.data?.message || error?.message };
    }
}

export const validateCreateDraftFromJson = async (payload) => {
    try {
        const response = await api.post('/campaign-drafts/import/create/validate', payload);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message,
            details: error?.response?.data
        };
    }
};

export const createDraftFromJson = async (payload) => {
    try {
        const response = await api.post('/campaign-drafts/import/create', payload);
        if (response?.status === 201 || response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message,
            details: error?.response?.data
        };
    }
};

export const listShopifyProductsForAi = async (params = {}) => {
    try {
        const response = await api.get(`/campaigns/shopify/products?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message,
            details: error?.response?.data
        };
    }
};

export const createDraftFromItinerary = async (formData) => {
    try {
        const response = await api.post('/campaigns/createdDraftCampaign/ai/itinerary-draft', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 600000,
        });
        if (response?.status === 201 || response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message,
            details: error?.response?.data,
        };
    }
};

export const createSmartCampaignDraft = async (formData) => {
    try {
        const response = await api.post('/campaigns/createdDraftCampaign/ai/smart-campaign-draft', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 600000,
        });
        if (response?.status === 201 || response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message,
            details: error?.response?.data,
        };
    }
};

export const createShopifyTemplateDraftAi = async (payload = {}) => {
    try {
        const response = await api.post('/campaigns/createdDraftCampaign/ai/shopify-template-draft', payload);
        if (response?.status === 201 || response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message,
            details: error?.response?.data
        };
    }
};

export const listShopifyAiProducts = listShopifyProductsForAi;
export const createDraftFromShopifyTemplateAi = createShopifyTemplateDraftAi;

export const exportDraftCampaignJson = async (draftId) => {
    try {
        const response = await api.get(`/campaign-drafts/${draftId}/settings/export`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message
        };
    }
};

export const exportPublishedCampaignJson = async (campaignId) => {
    try {
        const response = await api.get(`/campaign-drafts/published/${campaignId}/settings/export`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.response?.data?.error || error?.message
        };
    }
};

// Add deleteCampaignActorVideo function
export const deleteCampaignActorVideo = async (videoId) => {
    try {
        const response = await api.delete(
            `/campaign-actors/campaign-actor-videos/${videoId}`
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {error: error?.response?.data?.message};
    }
};

export const fetchCampaignActorVideoStatus = async (videoIds = []) => {
    try {
        const response = await api.post('/campaign-actors/fetchVideoStatus', { videoIds });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const getCampaignTags = async (campaign_id) => {
    try {
        const response = await api.get(`/campaigns/${campaign_id}/tags`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.error };
    }
}

export const addCampaignTags = async (campaign_id, tags) => {
    try {
        const response = await api.post(`/campaigns/${campaign_id}/tags`, { tags });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.error };
    }
}

export const removeCampaignTags = async (campaignId, mappingId) => {
    try {
        const response = await api.delete(`/campaigns/${campaignId}/tags/${mappingId}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.error };
    }
}

export const getVideoReviewData = async (videoId) => {
    try {
        const response = await api.get(`/ca-videos/${videoId}/review`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const getVideoConfigData = async (videoId) => {
    try {
        const response = await api.get(`/ca-videos/${videoId}/config`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const updateCampaignActorVideo = async (videoId, data) => {
    try {
        const response = await api.put(`/ca-videos/${videoId}`, data);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const translateVideoFields = async (videoId, data) => {
    try {
        const response = await api.post(`/ca-videos/${videoId}/translate`, data);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const regenerateVideoAudio = async (videoId, data) => {
    try {
        const response = await api.post(`/ca-videos/${videoId}/regenerate-audio`, data);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const updateTaskMedia = async (videoId, taskId, file, mediaField) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('mediaField', mediaField);
        const response = await api.put(
            `/ca-videos/${videoId}/tasks/${taskId}/media`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const listCampaignTemplates = async (params = {}) => {
    try {
        const { requirePreview = true, ...queryParams } = params || {};
        const sanitizedParams = Object.entries(queryParams).reduce((acc, [key, value]) => {
            if (
                value === undefined ||
                value === null ||
                value === '' ||
                value === 'undefined' ||
                value === 'null'
            ) {
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {});

        const response = await api.get(`/campaign-templates?${qs(sanitizedParams)}`);
        if (response?.status === 200) {
            const templates = response?.data?.templates || [];
            return {
                ...response.data,
                templates: requirePreview ? filterTemplatesWithPreview(templates) : templates
            };
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const listTemplateCategories = async () => {
    try {
        const response = await api.get('/campaign-templates/categories');
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const instantiateCampaignTemplate = async (templateId, payload = {}) => {
    try {
        const response = await api.post(`/campaign-templates/${templateId}/instantiate`, payload);
        if (response?.status === 201 || response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        const details = error?.response?.data || {};
        return {
            error: details?.message || error?.message,
            code: details?.code || null,
            paywall: details?.paywall || null,
            details,
        };
    }
};

export const createCampaignTemplate = async (payload = {}) => {
    try {
        const response = await api.post('/campaign-templates', payload);
        if (response?.status === 201 || response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const updateCampaignTemplate = async (templateId, payload = {}) => {
    try {
        const response = await api.patch(`/campaign-templates/${templateId}`, payload);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
    return { error: 'Template update failed.' };
};

export const importCampaignTemplate = async ({ file, jsonString, metadata = {} } = {}) => {
    try {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            if (metadata.title) formData.append('title', metadata.title);
            if (metadata.description) formData.append('description', metadata.description);
            if (metadata.thumbnail_url) formData.append('thumbnail_url', metadata.thumbnail_url);
            if (Array.isArray(metadata.tags)) {
                metadata.tags.forEach((tag) => formData.append('tags[]', tag));
            }
            if (metadata.category_key || metadata.category) {
                formData.append('category_key', metadata.category_key || metadata.category);
            }
            const response = await api.post('/campaign-templates/import', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (response?.status === 201 || response?.status === 200) {
                return response?.data;
            }
        } else {
            const response = await api.post('/campaign-templates/import', {
                json_string: jsonString,
                ...metadata
            });
            if (response?.status === 201 || response?.status === 200) {
                return response?.data;
            }
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.message,
            code: error?.response?.data?.code,
            details: error?.response?.data
        };
    }
    return { error: 'Template import failed.' };
};

export const exportCampaignTemplate = async (templateId, { download = false } = {}) => {
    try {
        const response = await api.get(`/campaign-templates/${templateId}/export`, {
            params: { download: download ? 'true' : 'false' }
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.message,
            code: error?.response?.data?.code,
            details: error?.response?.data
        };
    }
    return { error: 'Template export failed.' };
};

export const deleteCampaignTemplate = async (templateId) => {
    try {
        const response = await api.delete(`/campaign-templates/${templateId}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        const status = error?.response?.status;
        if (status === 404 || status === 405) {
            try {
                const fallbackResponse = await api.post(`/campaign-templates/${templateId}/delete`, {});
                if (fallbackResponse?.status === 200) {
                    return fallbackResponse?.data;
                }
            } catch (fallbackError) {
                return {
                    error: fallbackError?.response?.data?.message || fallbackError?.message,
                    code: fallbackError?.response?.data?.code,
                    details: fallbackError?.response?.data
                };
            }
        }
        return {
            error: error?.response?.data?.message || error?.message,
            code: error?.response?.data?.code,
            details: error?.response?.data
        };
    }
    return { error: 'Template delete failed.' };
};

export const makeSystemCampaignTemplate = async (templateId) => {
    try {
        const response = await api.patch(`/campaign-templates/${templateId}/make-system`, {});
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.message,
            code: error?.response?.data?.code,
            details: error?.response?.data
        };
    }
    return { error: 'Failed to promote template to system.' };
};

export const makePrivateCampaignTemplate = async (templateId) => {
    try {
        const response = await api.patch(`/campaign-templates/${templateId}/make-private`, {});
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return {
            error: error?.response?.data?.message || error?.message,
            code: error?.response?.data?.code,
            details: error?.response?.data
        };
    }
    return { error: 'Failed to demote template to private.' };
};

const catalogActionError = (error, fallback) => ({
    error: error?.response?.data?.message || error?.message || fallback,
    code: error?.response?.data?.code || null,
    details: error?.response?.data || null,
});

const CATALOG_GENERATE_POLL_MS = 2500;
const CATALOG_GENERATE_TIMEOUT_MS = 15 * 60 * 1000;

/** SuperAdmin: poll async catalog generate job until completed/failed. */
export const getCatalogGenerateJobStatus = async (jobId) => {
    try {
        const response = await api.get(`/campaign-templates/generate-jobs/${encodeURIComponent(jobId)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return catalogActionError(error, 'Failed to fetch catalog generate job.');
    }
    return { error: 'Failed to fetch catalog generate job.' };
};

/**
 * SuperAdmin: generate one catalog template by catalog_slug.
 * API returns 202 + job_id; this helper polls until ready (avoids App Service ~230s 504).
 */
export const generateCatalogCampaignTemplate = async (payload = {}, options = {}) => {
    try {
        const response = await api.post('/campaign-templates/generate', payload);
        if (response?.status === 200 || response?.status === 201) {
            return response?.data;
        }
        if (response?.status === 202 && response?.data?.job_id) {
            const pollMs = Number(options.pollMs) > 0 ? Number(options.pollMs) : CATALOG_GENERATE_POLL_MS;
            const timeoutMs = Number(options.timeoutMs) > 0
                ? Number(options.timeoutMs)
                : CATALOG_GENERATE_TIMEOUT_MS;
            const sleep = typeof options.sleep === 'function'
                ? options.sleep
                : (ms) => new Promise((resolve) => setTimeout(resolve, ms));
            const deadline = Date.now() + timeoutMs;
            const jobId = response.data.job_id;

            while (Date.now() < deadline) {
                await sleep(pollMs);
                const status = await getCatalogGenerateJobStatus(jobId);
                if (status?.error && !status?.status) {
                    return status;
                }
                if (status?.status === 'completed') {
                    return {
                        ...(status.result || {}),
                        job_id: status.job_id || jobId,
                        catalog_slug: status.catalog_slug || status.result?.catalog_slug || payload.catalog_slug,
                        template_id: status.template_id || status.result?.template_id || null,
                        generation_status: status.generation_status || status.result?.generation_status || 'ready',
                        tokenUsage: status.result?.tokenUsage || null,
                    };
                }
                if (status?.status === 'failed') {
                    return {
                        error: status.error?.message || status.message || 'Failed to generate catalog template.',
                        code: status.error?.code || null,
                        details: status.error?.details || status,
                    };
                }
            }
            return { error: 'Timed out waiting for catalog template generate.' };
        }
    } catch (error) {
        return catalogActionError(error, 'Failed to generate catalog template.');
    }
    return { error: 'Failed to generate catalog template.' };
};

/** SuperAdmin: generate all catalog rows that are not ready. */
export const generateMissingCatalogCampaignTemplates = async (payload = {}) => {
    try {
        const response = await api.post('/campaign-templates/generate-missing', payload);
        if (response?.status === 200 || response?.status === 201) {
            return response?.data;
        }
    } catch (error) {
        return catalogActionError(error, 'Failed to generate missing catalog templates.');
    }
    return { error: 'Failed to generate missing catalog templates.' };
};

/** SuperAdmin: generate templates for a sector_key. */
export const generateSectorCatalogCampaignTemplates = async (payload = {}) => {
    try {
        const response = await api.post('/campaign-templates/generate-sector', payload);
        if (response?.status === 200 || response?.status === 201) {
            return response?.data;
        }
    } catch (error) {
        return catalogActionError(error, 'Failed to generate sector catalog templates.');
    }
    return { error: 'Failed to generate sector catalog templates.' };
};

/** SuperAdmin: update catalog template with prompt (+ optional RAG retrain). */
export const updateCatalogCampaignTemplateWithPrompt = async (templateId, payload = {}) => {
    try {
        const response = await api.post(`/campaign-templates/${templateId}/update-with-prompt`, payload);
        if (response?.status === 200 || response?.status === 201) {
            return response?.data;
        }
    } catch (error) {
        return catalogActionError(error, 'Failed to update template with prompt.');
    }
    return { error: 'Failed to update template with prompt.' };
};

/** SuperAdmin: open system catalog template as a hidden template_edit scratch draft. */
export const openSystemTemplateForEdit = async (templateId) => {
    try {
        const response = await api.post(`/campaign-templates/${templateId}/open-for-edit`, {});
        if (response?.status === 200 || response?.status === 201) {
            return response?.data;
        }
    } catch (error) {
        return catalogActionError(error, 'Failed to open template for edit.');
    }
    return { error: 'Failed to open template for edit.' };
};

/** SuperAdmin: overwrite system catalog portable_settings from a template_edit draft. */
export const saveSystemTemplateFromDraft = async (templateId, draftId) => {
    try {
        const response = await api.post(`/campaign-templates/${templateId}/save-from-draft`, {
            draft_id: draftId,
        });
        if (response?.status === 200 || response?.status === 201) {
            return response?.data;
        }
    } catch (error) {
        return catalogActionError(error, 'Failed to save template from draft.');
    }
    return { error: 'Failed to save template from draft.' };
};

export const updateDraftSourceClassification = async (draftId, payload = {}) => {
    try {
        const response = await api.patch(`/campaigns/drafts/${draftId}/source-classification`, payload);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
    return { error: 'Draft source classification update failed.' };
};

export const updateCampaignSourceClassification = async (campaignId, payload = {}) => {
    try {
        const response = await api.patch(`/campaigns/${campaignId}/source-classification`, payload);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
    return { error: 'Campaign source classification update failed.' };
};